import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs';
import { SocketService, SocketMessageFE, ProcessType, SocketLog, PrintJsonMessage } from './../../services/socket.service';
import { SocketProcess, CommonSocketMsgComponent } from './../common-socket-msg/common-socket-msg.component';
import { CancelTranscService } from './../../services/cancel-transc.service';
import { LayerQcService } from './../../services/layer-qc.service';
import { TransactionLogService } from 'app/services/transaction-log.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { ViewLogComponent } from './view-log/view-log.component';

export interface LongTransaction {
	id: string;
	type: string;
	status: 'Preparing' | 'Processing' | 'Completed' | 'Error' | 'Canceling' | 'Canceled';
	messages: {
    message: string,
    time;
    type: 'err' | 'info'
  }[];
	// printJsonMessages?: PrintJsonMessage[];
	endTime?: Date | string;
  info: {[prop: string]: any};
  hideMessage: boolean;

  clickedCancel?: boolean;
}


@Component({
  selector: 'app-feat-transaction-log',
  templateUrl: './feat-transaction-log.component.html',
  styleUrls: ['./feat-transaction-log.component.css']
})
export class FeatTransactionLogComponent implements OnInit {
  public processes: LongTransaction[] = [];
  private processesSub: Subscription;

  constructor(
    private cdRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<FeatTransactionLogComponent>,
    private modalService: CommonModalService,
    private transactionLogService: TransactionLogService
  ) { }

  cancel() {
    this.dialogRef.close();
  }

  async cancelProcess(process: LongTransaction) {
    if (process.clickedCancel) {
      return;
    }
    process.clickedCancel = true;
    this.transactionLogService.socketProcesses.next(this.processes);
    try {
      await this.transactionLogService.cancelProcess(process.id);
    } catch (err) {
      console.log(err);
    }
  }
  async viewLog(process: LongTransaction) {
    // TODO
    const options: MatDialogConfig = {
      data: process,
      height: '90%',
      width: '90%'
    }
    this.modalService.openModalWindow(ViewLogComponent, options);
  }

  checkIsLive(process: LongTransaction): boolean {
    return process.status!=='Completed' && process.status!=='Canceled' && process.status!=='Error';
  }

  // hideProcessMessage(processId: string) {
  //   for(let i = 0; i < this.processes.length; i ++) {
  //     let p = this.processes[i];
  //     if(p.id == processId) {
  //       if(p.hideMessage) {
  //         p.hideMessage = false;
  //       } else {
  //         p.hideMessage = true;
  //       }
  //       break;
  //     }
  //   }
	// 	this.transactionLogService.socketProcesses.next(this.processes);
  // }

  ngOnInit() {
    this.processesSub = this.transactionLogService.socketProcesses.subscribe((data) => {
      this.processes = JSON.parse(JSON.stringify(data));
      console.log(this.processes)
    })
  }

  ngOnDestroy() {
    this.processesSub.unsubscribe()
  }

}
